import type { TFunction } from 'i18next';
import { isWagerFreeActivatedCash } from 'modules/bonuses/helpers/wagerFreeCash';
import type { GlobalTooltipConfig } from 'modules/globalTooltip/store';
import type { TReceivedBonus } from './tooltipConfigs';
import { EReceivedBonusKind, TOOLTIP_CONFIG_BY_KIND } from './tooltipConfigs';

interface IReceivedBonusKindRule {
  kind: EReceivedBonusKind;
  isSatisfiedBy: (bonus: TReceivedBonus) => boolean;
}

const RECEIVED_BONUS_KIND_RULES: IReceivedBonusKindRule[] = [
  {
    kind: EReceivedBonusKind.WagerFreeCash,
    isSatisfiedBy: isWagerFreeActivatedCash,
  },
];

const getReceivedBonusKind = (bonus: TReceivedBonus): EReceivedBonusKind => {
  const matchedRule = RECEIVED_BONUS_KIND_RULES.find(({ isSatisfiedBy }) =>
    isSatisfiedBy(bonus)
  );

  return matchedRule?.kind ?? EReceivedBonusKind.Default;
};

export const getReceivedBonusTooltipConfig = (
  bonus: TReceivedBonus,
  t: TFunction
): GlobalTooltipConfig =>
  TOOLTIP_CONFIG_BY_KIND[getReceivedBonusKind(bonus)](bonus, t);
